import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { CalendarDays, FileText, CheckCircle2 } from 'lucide-react';
import { releaseEntries } from '@/config/releases';

export default function ChangelogPage() {
  return (
    <div className="space-y-6" data-testid="changelog-page">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-[#0F172A]" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
          Changelog
        </h1>
        <p className="text-sm text-[#475569] mt-1">Historial resumido de cambios relevantes del sistema</p>
      </div>

      <div className="grid gap-4">
        {releaseEntries.map((entry, index) => (
          <Card key={`${entry.version}-${entry.date}`} className="border-[#E2E8F0] shadow-sm">
            <CardHeader className="pb-3">
              <div className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between sm:gap-3">
                <div className="min-w-0">
                  <CardTitle className="text-base sm:text-lg font-semibold text-[#0F172A]">{entry.title}</CardTitle>
                  <div className="mt-1 flex flex-wrap items-center gap-2 text-xs text-[#64748B]">
                    <CalendarDays size={13} className="shrink-0" />
                    <span className="tabular-nums">{entry.datetime}</span>
                    <span className="text-[#CBD5E1]">|</span>
                    <span className="tabular-nums">v{entry.version}</span>
                    {entry.commit && (
                      <>
                        <span className="text-[#CBD5E1]">|</span>
                        <span className="tabular-nums">commit {entry.commit}</span>
                      </>
                    )}
                  </div>
                </div>
                <Badge variant="outline" className={`w-fit shrink-0 ${index === 0 ? 'bg-violet-50 text-violet-700 border-violet-200' : 'bg-[#EFF6FF] text-[#2563EB] border-[#2563EB]/20'}`}>
                  <CheckCircle2 size={12} className="mr-1" />
                  {index === 0 ? 'Release actual' : 'Release'}
                </Badge>
              </div>
            </CardHeader>
            <CardContent className="space-y-3">
              <p className="text-sm text-[#475569]">{entry.summary}</p>
              {entry.items.map((item) => (
                <div key={item} className="flex items-start gap-2 rounded-lg bg-[#F8FAFC] px-3 py-2 text-sm text-[#475569]">
                  <FileText size={14} className="mt-0.5 shrink-0 text-[#94A3B8]" />
                  <span>{item}</span>
                </div>
              ))}
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
